import { rechargeApiRequest } from '../utils/request.js';
async function getCharge(session, id, options) {
  const {
    charge
  } = await rechargeApiRequest("get", `/charges`, {
    id,
    query: {
      include: options?.include
    }
  }, session);
  return charge;
}
function listCharges(session, query) {
  return rechargeApiRequest("get", `/charges`, {
    query
  }, session);
}
async function applyDiscountToCharge(session, id, discountCode) {
  const {
    charge
  } = await rechargeApiRequest("post", `/charges/${id}/apply_discount`, {
    data: {
      discount_code: discountCode
    }
  }, session);
  return charge;
}
async function removeDiscountsFromCharge(session, id) {
  const {
    charge
  } = await rechargeApiRequest("post", `/charges/${id}/remove_discount`, {}, session);
  return charge;
}
async function skipCharge(session, id, purchaseItemIds, query) {
  const {
    charge
  } = await rechargeApiRequest("post", `/charges/${id}/skip`, {
    query,
    data: {
      purchase_item_ids: purchaseItemIds.map(id2 => Number(id2))
    }
  }, session);
  return charge;
}
async function unskipCharge(session, id, purchaseItemIds, query) {
  const {
    charge
  } = await rechargeApiRequest("post", `/charges/${id}/unskip`, {
    query,
    data: {
      purchase_item_ids: purchaseItemIds.map(id2 => Number(id2))
    }
  }, session);
  return charge;
}
async function processCharge(session, id) {
  const {
    charge
  } = await rechargeApiRequest("post", `/charges/${id}/process`, {}, session);
  return charge;
}
export { applyDiscountToCharge, getCharge, listCharges, processCharge, removeDiscountsFromCharge, skipCharge, unskipCharge };